// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".errorBorder{border:1px solid red}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/messages/sendMessage/sendMessage.scss"],"names":[],"mappings":"AAAA,aACE,oBAAqB","file":"sendMessage.scss","sourcesContent":[".errorBorder{\n  border: 1px solid red;\n}"]}]);
// Exports
module.exports = exports;
